<div class="initiative-fields-block" style="margin-top:1% !important;" [style.min-height]="showLoader ? '10rem' : null">
  <div class="top-buttons-block">
    <button
      *ngIf="isSystemAdmin || isAdmin"
      (click)="enableNewField()"
      [disabled]="noFieldsToEnable"
      [title]="noFieldsToEnable ? 'No Fields to Enable' : 'Enable Field'"
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
    >
      Enable
    </button>

    <div (click)="exportToExcel()" class="m-2">
      <span
        title="Click to Download"
        class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
      ></span>
    </div>
  </div>
  <div class="main-div-with-white-bkg" *ngFor="let field of fieldDataArr">
    <mat-accordion>
      <mat-expansion-panel
        [expanded]="field.isOpen"
        [hideToggle]="true"
        (opened)="field.isOpen = true"
        (closed)="field.isOpen = false"
      >
        <mat-expansion-panel-header
          class="prevent-click expansion-Header-Width"
          style="padding-left: 0.08% !important; padding-right: 0px !important;"
        >
          <mat-panel-title class="matPanelTitle">
            <div class="pointer-event-auto mb-1">
              <span
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Cloud'"
                class="uitk-icon uitk-icon-arrow_right expansion-sm-icon"
                style="cursor: pointer;"
                *ngIf="field?.isOpen == false"
              ></span>
              <span
                class="uitk-icon uitk-icon-arrow_down expansion-sm-icon"
                style="cursor: pointer;"
                *ngIf="field?.isOpen == true"
              ></span>
            </div>

            <div
              class="row no-gutters col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 mb-1"
              style="padding-left: 0px !important; padding-right: 0px !important;"
            >
              <div>
                <div class="config-attribute-container-left table-Header-Nav utik-div" style="padding-left: 0.8rem;">
                  {{ field?.displayName }}
                </div>
              </div>
            </div>
          </mat-panel-title>
          <mat-panel-description>
            <div class="expand-button-div">
              <span *ngIf="isAdmin || isSystemAdmin">
                <button
                  [disabled]="
                    !(
                      field?.isOpen &&
                      ((field?.name == 'Generic' && reorderRowsForGeneric?.length > 0) ||
                        (field?.name == 'Calc_initiative' && reorderRowsForCalcInitiative?.length > 0) ||
                        (field?.name == 'Initiative' && reorderRowsForInitiative?.length > 0))
                    )
                  "
                  (click)="onApply(field?.name); $event.stopPropagation()"
                  class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                >
                  Apply
                </button>
              </span>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="row p-0">
          <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 p-0">
            <ng-container>
              <app-field-management-table
                [type]="field?.name"
                [tableData]="field.tableData"
                [columns]="field.displayedColumns"
                [calc_columns]="displayedColumnsForCalcInitiative"
                [admin]="isAdmin"
                [systemAdmin]="isSystemAdmin"
                [isUpdated]="field?.isUpdated"
                (getReorderedArr)="getReorderRows($event, field?.name)"
                [initiativeId]="initiativeId"
                [editRolesOptions]="editRolesOptions"
                (updateFieldData)="updateFieldData($event)"
                [fieldDataArr]="fieldDataArr"
              ></app-field-management-table>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div *ngIf="!showLoader && fieldDataArr.length == 0" class="noFieldsDiv">
    <span>
      No fields are available. Please click the Enable button to enable the fields
    </span>
  </div>
</div>
<div *ngIf="showLoader" class="row enterprise-initiative-field-management-loader">
  <app-loader style="stroke:  #002677 !important;"></app-loader>
</div>
<div>
  <app-modal
    [maximizable]="true"
    [inViewport]="true"
    #modalEnableField
    class="modal-demo enable-field-popup"
    (closeModal)="closemodal()"
  >
    <ng-container class="app-modal-header">Enable Field</ng-container>
    <ng-container class="app-modal-body ">
      <app-enable-field-popup
        [(clearFormFields)]="clearFormFields"
        [categories]="categoryList"
        [editRolesOptions]="editRolesOptions"
        [initiativeId]="initiativeId"
        [fieldData]="fieldDataArr"
        (emitReqPayload)="submitEnableField($event)"
      >
      </app-enable-field-popup>
    </ng-container>
  </app-modal>
</div>
